import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { seventhFlowsActions } from 'features/seventhFlows';

const useSeventhFlows = () => {
  const dispatch = useDispatch();
  const getSeventhFlow = useCallback(() => dispatch(seventhFlowsActions.getSeventhFlow()), [dispatch]);
  const createSeventhFlow = useCallback(seventh_flow => dispatch(seventhFlowsActions.createSeventhFlow(seventh_flow)), [dispatch]);
  const updateSeventhFlow = useCallback(seventh_flow => dispatch(seventhFlowsActions.updateSeventhFlow(seventh_flow)), [dispatch]);
  const deleteSeventhFlow = useCallback(() => dispatch(seventhFlowsActions.deleteSeventhFlow()), [dispatch]);
  const clearLocalActiveSeventhFlow = useCallback(() => dispatch(seventhFlowsActions.clearLocalActiveSeventhFlow()), [dispatch]);

  return {
    getSeventhFlow,
    createSeventhFlow,
    updateSeventhFlow,
    deleteSeventhFlow,
    clearLocalActiveSeventhFlow
  };
};

export default useSeventhFlows;